import React, { Component } from 'react'
import { FastField } from "formik"
import { NumberInput, NUMBER_FORMAT_LATIN } from 'react-hichestan-numberinput'

export default function DigitInput(props) {
  const { label, fieldName, error, fullWidth, autoFocus, placeHolder, halfWidth, maxLength, required } = props;

  return (
    <React.Fragment>
      <div className={fullWidth ? "col-lg-12 col-sm-12" : halfWidth ? "col-lg-6 col-sm-12" : "col-lg-3 col-sm-12"}>
        <label>{required ? <span className="red">*</span> : ''}{label}</label>
        <FastField
          as={NumberInput}
          maxLength={maxLength}
          autoFocus={autoFocus}
          type="text"
          name={fieldName}
          placeHolder={placeHolder}
          className={error ? "text-input text-right has-error" : "text-input text-right"}
          // onChange={onChange}
          {...props}
        />
      </div>
    </React.Fragment>
  );
}